import { Box, BoxProps } from '@jfs/ui-new'
import { FC, ReactElement } from 'react'
import ReactDOM from 'react-dom'
import { ScrollView, ViewProps } from 'react-native'
import { styles } from './styles'

export enum ModalTypes {
  Default = 'Default',
  Alert = 'Alert',
  Loader = 'Loader',
  Error = 'Error',
  SELECTOR = 'SELECTOR',
  NOTIFICATION = 'NOTIFICATION',
  ALL_NOTIFICATIONS = 'ALL_NOTIFICATIONS',
  TRX_DETAILS = 'TRX_DETAILS',
  ADMIN_PORTAL_DIALOG = 'ADMIN_PORTAL_DIALOG',
  NAVBAR = 'NAVBAR',
  NAVBAR_RIGHT = 'NAVBAR_RIGHT',
  MODAL_BOTTOM = 'MODAL_BOTTOM',
  ERROR_TOP = 'ErrorTop',
}
export interface ModalProps {
  visible: boolean
  view: ReactElement | FC
  embedInScrollView?: boolean
  onPress?: () => void
  type?: ModalTypes
}

const TransactionDetails = (type: ModalTypes, innerView: ReactElement, onPress?: () => void) => {
  return (
    <>
      <Box {...styles[type].modalContainer} onPress={onPress} underlayColor={'TRANSPARENT'}>
        <Box />
      </Box>
      <Box {...styles[type].container} pointerEvents={'box-none'}>
        {innerView}
      </Box>
    </>
  )
}

const Modal = ({
  view,
  visible,
  embedInScrollView = true,
  onPress,
  type = ModalTypes.Default,
}: ModalProps): ReactElement | null => {
  if (!visible) {
    return null
  }

  const modalContainer = (): JSX.Element => {
    const getView = (): ReactElement => {
      if (embedInScrollView) {
        return <ScrollView style={styles[type].scrollView as ViewProps}>{view}</ScrollView>
      }
      return <Box {...(styles[type].scrollView as BoxProps)}>{view}</Box>
    }

    const innerView = getView()

    if (type === ModalTypes.TRX_DETAILS) {
      TransactionDetails(type, innerView, onPress)
    }

    return (
      <Box {...styles[type].modalContainer} onPress={onPress} underlayColor={'TRANSPARENT'}>
        <Box {...styles[type].container}>{innerView}</Box>
      </Box>
    )
  }

  return ReactDOM.createPortal(modalContainer(), document.body)
}

export { Modal }
